import { ReactElement } from 'react'
import { Text } from '../../Atoms'
import usePicker from './hooks'
import { PickerProps } from './props'
import {
    SelectedHighlight,
    StyledPicker,
    StyledPickerItem,
    StyledPickerItems,
} from './styles'

const Picker = ({
    itemHeight = 40,
    onChange,
    options,
    pickerHeight = 280,
    suffix,
    value,
    ...props
}: PickerProps): ReactElement => {
    const pickerProps = { itemHeight, onChange, options, pickerHeight, value }
    const pickerUtils = usePicker(pickerProps)

    const { currentIndex, isMoving, draggers, translate } = pickerUtils
    const { moveDrag, startDrag, stopDrag, wheelDrag } = draggers

    const pickerItems = options.map(({ label }, key) => (
        <StyledPickerItem
            css={{
                h: itemHeight,
                minH: itemHeight,
                lineHeight: `${itemHeight}px`,
                ...(suffix && {
                    gridTemplateColumns: '1fr 1fr',
                }),
            }}
            isSelected={key === currentIndex}
            key={key}
        >
            {label}
        </StyledPickerItem>
    ))

    return (
        <StyledPicker {...props}>
            <StyledPickerItems
                css={{
                    h: pickerHeight,
                }}
                isMoving={isMoving}
                onMouseDown={startDrag}
                onMouseMove={moveDrag}
                onMouseUp={stopDrag}
                onTouchEnd={stopDrag}
                onTouchMove={moveDrag}
                onTouchStart={startDrag}
                onWheel={wheelDrag}
                style={{
                    transform: `translate3d(0, ${translate}px, 0)`,
                }}
            >
                {pickerItems}
            </StyledPickerItems>
            <SelectedHighlight css={{ h: itemHeight }}>
                {suffix && <Text css={{ gridArea: 'right' }}>{suffix}</Text>}
            </SelectedHighlight>
        </StyledPicker>
    )
}

export default Picker

export { StyledPicker }
